import { Roles } from '../auth/roles';

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  pictureUrl?: string;
  accessToken: string;
  accessTokenExpiryTime: string;
  refreshToken: string;
  roles?: Roles;
}

export const userFullName = (user: User | null): string | undefined => {
  if (user?.firstName && user?.lastName) {
    return `${user.firstName} ${user.lastName}`;
  } else if (user?.firstName) {
    return user.firstName;
  } else if (user?.lastName) {
    return user.lastName;
  } else {
    return undefined;
  }
};
